export default "__VITE_ASSET__50b2106c__"